export default __webpack_public_path__ + "static/media/feed1.ccebe7e5.jpg";